const getPositioningBoundingArea = (element) => {
  const compositeGroup = element.closest('ws-composite-group');

  if (!element.matches('ws-composite-group') && compositeGroup) {
    const positioningArea = compositeGroup.getPositioningAreaElement();

    return {
      element: positioningArea,
      boundingRect: positioningArea.getBoundingClientRect(),
    };
  }

  const positioningArea = element.parentElement;

  return {
    element: positioningArea,
    boundingRect: positioningArea.getBoundingClientRect(),
  };
};

export default getPositioningBoundingArea;
